'use strict';

var ajax = require('../../ajax'),
	progress = require('../../progress'),
	util = require('../../util'),
	einstein = require('../../einstein'),
	googletaglinchpin = require('int_googletagmanager/googletaglinchpin'),
	wishlist = require('../wishlist'),
	lazyloading = require('../../lazyloading');

	// for keeping track of selections for 'taste adventure'
var firstLoad = true,
	// for keeping track on if a location has been selected for a tasting adventure
	noLocation = $('.va-tastingAdventureLocation').length > 0 ? true : false;


/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 **/
var updateContent = function (href) {
	var $pdpForm = $('.pdpForm'),
		qty = $pdpForm.find('input[name="Quantity"]').first().val(),
		params = {
			Quantity: isNaN(qty) ? '1' : qty,
			source: 'pdp',
			productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
		};

	progress.show($('#pdpMain'));

	ajax.load({
		url: util.appendParamsToUrl(href, params),
		target: $('#product-detail-wrapper'),
		callback: function () {
			$(window).trigger('productChanged');
			$(document).trigger('productVariationChanged');
			if (noLocation) {
				// keep states for 'taste adventure' upon selection of location variation attribute
				$('#va-tastingAdventureDateTime').prop('selectedIndex', 0).change();
				$('.va-tastingAdventureDateTime').parent().show();
				$('.btn-number, input[name="Quantity"], .add-to-cart').prop('disabled', true);
				noLocation = false;
			}
			if ($('#va-tastingAdventureDateTime').prop('selectedIndex') > 0) {
				$('.availability-block').show();
			}
			// re-init quick-view tabs
			$('.pdp-main .product-qv-tabs .product-tabs').tabs ({
				collapsible: true,
				active: false
			});

			einstein.onEinstainContentAdded('.recommendations-pdp', function () {
				$('.recommendations-pdp #carousel-recommendations').slick(util.sliderConfigs({instandard:4, inlarge:3, inmedium:2, insmall:1}));
			});

			// re-init namespace specific events for Linchpin GTM analytics
			if (SitePreferences.GTM_ENABLED) {
				if (window.pageContext.ns) {
					googletaglinchpin.init(window.pageContext.ns);
				}
			}
			util.limitCharacters();

			if (window.Klarna && window.Klarna.OnsiteMessaging) {
				window.Klarna.OnsiteMessaging.refresh();
			}

			wishlist.markWishlistProducts();

			if (SitePreferences.LAZYLOAD_ENABLED) {
				lazyloading.init();
			}
		}
	});

	$('.va-tastingAdventureDateTime').parent().show();
};

module.exports = function () {
	var $pdpMain = $('#pdpMain');
	// hover on swatch - should update main image with swatch image

	// change drop down variation attribute - should replace product content with new variant
	$pdpMain.on('change', '.variation-select', function () {
		if ($(this).val().length === 0) {
			// update reserve all specials button state if it exists on a page
			if ($('.reserve-all-specials').length > 0) {
				$('.reserve-all-specials').prop('disabled', true);
			}
			// disable the add to cart button
			$(this).closest('#product-content').find('.add-to-cart').prop('disabled', true);
			return;
		}
		updateContent($(this).val());
	});

	// handle custom variants update via item click
	$pdpMain.on('click', '.variant-selection .variant-item', function (e) {
		e.preventDefault();
		if ($(this).hasClass('selected')) {
			return;
		}
		var updateURL = $(this).data('url');
		updateContent(updateURL);
	});

	// prevent from adding e gift card product to cart if no variant selected
	$('.product-add-to-cart').on('change', 'input.required', function () {
		if ($pdpMain.find('.variation-select').length < 1 || $pdpMain.find('.variation-select').val().length > 0) {
			return;
		}
		// disable the add to cart button
		$('.add-to-cart').prop('disabled', true);
	});

	// change variation content for sleeve option
	$pdpMain.on('change', '.sleeveSelect', function () {
		var selectedUrl = $(this).find('.sleeve.selected').length ? $(this).find('.sleeve.selected').data('url') : $(this).data('default');
		if (!selectedUrl) { return; }
		updateContent(selectedUrl);
		if (util.viewport.isMobile()) {
			$('html, body').animate({scrollTop: 0});
		}
	});

	// prepare the 'taste adventure' pdp
	if ($('#taste-adventure').length > 0) {
		if (firstLoad) {
			$(document).ready(function () {
				$('#va-tastingAdventureLocation').prop('selectedIndex', 0).change();
				$('.va-tastingAdventureDateTime').parent().hide();
				$('.btn-number, input[name="Quantity"], .add-to-cart').prop('disabled', true);
				firstLoad = false;
			});
		}
		$('.availability-block').hide();
	}

};
